// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-box[data-v-fc8f77be]{width:1120px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:#333;font-size:17px}.title-box .btn[data-v-fc8f77be]{margin-top:0}", ""]);
// Exports
module.exports = exports;
